import { z } from 'zod';

import { extractErrorMessageFromZodError } from '@/lib/errors/errors';
import getApiClient from '@/shared/api/api-client/getApiClient';

const responseSchema = z.object({
  enabled: z.boolean(),
});

export async function getFacebookBetaStatus(): Promise<
  { enabled: boolean; isOk: true } | { errorMessage: string; isOk: false }
> {
  const client = getApiClient();
  const response = await client.get('/api/facebook/beta/status');

  if (!response.ok) {
    return { errorMessage: await response.errorMessage(), isOk: false };
  }

  const json = await response.json();
  const result = responseSchema.safeParse(json);

  if (!result.success) {
    return {
      errorMessage: extractErrorMessageFromZodError(
        result.error,
        "Can't parse response [GET /api/facebook/beta/status]",
      ),
      isOk: false,
    };
  }

  return { enabled: result.data.enabled, isOk: true };
}
